import { Component, Input, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'app-placeholder-swiper',
  templateUrl: './placeholder-swiper.component.html',
  styleUrls: ['./placeholder-swiper.component.scss'],
})
export class PlaceholderSwiperComponent implements OnInit {
  readonly swiperConfig: SwiperOptions = {
    breakpoints: {
      0: {
        slidesPerView: 3.6,
        slidesPerGroup: 3,
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16,
      },
      768: {
        slidesPerView: 4.35,
        slidesPerGroup: 4,
        slidesOffsetAfter: 32,
        slidesOffsetBefore: 32,
      },
      1024: {
        slidesPerView: 6.35,
        slidesPerGroup: 6,
        slidesOffsetAfter: 32,
        slidesOffsetBefore: 32,
      },
      1200: {
        slidesPerView: 6.35,
        slidesPerGroup: 6,
        slidesOffsetAfter: 48,
        slidesOffsetBefore: 48,
      },
      1440: {
        slidesPerView: 7.5,
        slidesPerGroup: 7,
        slidesOffsetAfter: 48,
        slidesOffsetBefore: 48,
      },
      1800: {
        slidesPerView: 9,
        slidesPerGroup: 8,
        slidesOffsetAfter: 48,
        slidesOffsetBefore: 48,
      },
    },
    enabled: false,
    navigation: {
      enabled: false,
    },
    spaceBetween: 32,
  };

  constructor() {
  }

  ngOnInit() {
  }
}
